/*    
<summary>
   This file is used to provide initial values or state to the Fota Module observables.
   Developer: Aashish Singh, Created Date: 28-August-2024
</summary>
*/

import { IDeviceFotaStatusListVm } from "../../models/response/IFotaSchedulerDeviceStatusResponse";

export const initialFotaSchedulerDeviceStatusState: IDeviceFotaStatusListVm= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    DevicesFotaStatusHistory: []
}